<template>
  <div v-if="open" class="fixed top-0 w-full z-50">
    <div class="na-content flex flex-col items-center text-sm lg:text-base text-black-900 relative rounded py-2 bg-blue-200">
      {{ message }}
      <button @click="open = false" type="button" class="block normal-case btn btn-sm btn-border mt-0 px-2 py-1">Dismiss</button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        open: true,
      }
    },
    methods: {
    },
    props: {
      'message': String,
    }
  }
</script>
